import { Button, Stack } from "@mui/material";
import { useState } from "react";

import { BalanceCard } from "Billing/Components/BalanceCard";
import { DepositModal } from "Billing/Components/DepositModal";
import { TransactionHistoryTable } from "Billing/Components/TransactionHistoryTable";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const BillingPage = (): React.ReactNode => {
  const { t } = useResource();
  const [isDepositModalOpen, setIsDepositModalOpen] = useState(false);

  return (
    <AuthenticatedLayout
      title={t(Resources.Common.Wallet)}
      action={
        <Button variant="contained" onClick={() => setIsDepositModalOpen(true)}>
          {t(Resources.Billing.InitiateDeposit)}
        </Button>
      }
    >
      <Stack spacing={Spacing.L}>
        <BalanceCard />
        <TransactionHistoryTable />
      </Stack>
      <DepositModal
        isOpen={isDepositModalOpen}
        onClose={() => setIsDepositModalOpen(false)}
      />
    </AuthenticatedLayout>
  );
};
